<template>
  <div>
    <div v-for="option in optionsAnswered" :key="option.id" class="row p-2">
      <div class="col--12">
        <div v-if="!option.other">
          <check-box
            :label="option.name"
            :checked="option.selected"
            :disabled="viewMode"
            @click="checkItem(option, $event)"
          />
        </div>
        <div v-else>
          <check-box
            :label="option.name"
            :checked="option.selected"
            :disabled="viewMode"
            @click="checkItem(option, $event)"
          />
          <AppInput type="text" :input-value="otherText" :is-disabled="!option.selected" :is-readonly="viewMode"
                    @blur="answered(option.id)" @change="valueChange" />
          <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckBox from '../../CheckBox.vue';
import AppInput from "../../AppInput.vue";

export default {
  'name': 'MultipleOption',
  components: { AppInput, CheckBox },
  'props': [
    'questionOptions',
    'answerName',
    'viewMode'
  ],
  'methods': {
    valueChange(e) {
      this.otherText = e.detail.value;

      if (this.otherText.trim() === '') {
        this.answered(this.optionsAnswered, '');
      } else {
        this.answered(this.optionsAnswered, this.otherText);
      }
    },
    checkItem(option, e) {
      if (!this.viewMode) {
        option.selected = !option.selected;
        let text
        this.optionsAnswered.forEach((q) => {
          if (q.selected && q.other) {
            text = this.otherText
          } else {
            text = null
          }
        })
        if (option.conditional) {
          this.$emit('onShowHideConditional', option, option.selected)
        }
        this.answered(this.optionsAnswered, text)
      } else {
        e.preventDefault();
      }
    },
    answered(answeredOptionsQuestion, text) {
      this.$emit('onAnswered', answeredOptionsQuestion, text)
    },
    checkConditionals() {
      this.questionOptions.forEach((option) => {
        if (option.conditional) {
          this.$emit('onShowHideConditional', option, option.selected)
        }
      })
    }
  },
  data() {
    return {
      // 'allOption': '',
      'flag': false,
      'optionsAnswered': [],
      'otherText': null
    }
  },
  watch: {
    questionOptions(newValue) {
      this.optionsAnswered = newValue;
    }
  },
  created() {
    // this.allOption = 'false'
    this.flag = false
    this.optionsAnswered = this.questionOptions
    this.otherText = this.answerName;
    // this.allOption = this.checkFullChecked()
  },
  mounted() {
    this.checkConditionals()
  }
}
</script>
